import { toReadableDate } from '@/lib/dates';
import logo from '@/public/assets/logo/pigello_blue.svg';
import type { IReleaseNote } from './release-notes-sheet-content';

export function ReleaseNote({ note }: { note: IReleaseNote }) {
  return (
    <div className='flex items-start gap-2'>
      <img
        src={logo.src}
        alt='Pigello Logo'
        className='size-8 rounded-full object-contain'
      />
      <div className='flex flex-col gap-1'>
        <div className='font-medium'>{note.title}</div>
        <div className='flex gap-2'>
          <div>{note.content}</div>
        </div>
        <p className='w-full text-xs text-muted-foreground'>
          {toReadableDate(String(note.date.toISODate()))}
        </p>
      </div>
    </div>
  );
}
